<template>
  <div>
    <p class="headline" v-html="$t('tutorial.stepHelp.TITLE')"></p>
    <p class="subheading" style="text-align: justify" v-html="$t('tutorial.stepHelp.BODY')"></p>
    <v-container>
      <v-layout>
        <v-btn @click.native="$emit('back')" flat>{{ $t('tutorial.buttons.BACK') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="selected < 3" @click.native="$emit('continue')">{{ $t('tutorial.buttons.CONTINUE') }}</v-btn>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'tutorial-step3'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialStep3.vue